import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor HTTP qui ajoute automatiquement l'ID de l'espace courant dans les headers
 * Compatible avec Angular SSR
 * Lit directement depuis localStorage pour éviter les dépendances circulaires
 */
export const spaceInterceptor: HttpInterceptorFn = (req, next) => {
  // En SSR, on passe la requête sans modification
  if (typeof window === 'undefined') {
    return next(req);
  }

  // Liste des URLs à exclure de l'ajout du spaceId
  const excludedUrls = [
    '/assets/',
    '/api/public/',
    '/auth/',
    '/spaces', // Les routes de gestion des espaces elles-mêmes
    '/status-check/', // Endpoints Keycloak status-check (request-otp, verify-otp, submit-record)
  ];

  const shouldExclude = excludedUrls.some(url => req.url.includes(url));
  if (shouldExclude) {
    return next(req);
  }

  // Lire directement depuis localStorage pour éviter les dépendances circulaires
  // Le SpaceContextService stocke l'ID de l'espace courant dans localStorage
  try {
    const currentSpaceId = localStorage.getItem('current_space_id');
    
    if (currentSpaceId) {
      // Cloner la requête et ajouter le header X-Space-Id
      const clonedReq = req.clone({
        setHeaders: {
          'X-Space-Id': currentSpaceId
        }
      });
      return next(clonedReq);
    }
  } catch (error) {
    // En cas d'erreur (localStorage non disponible), continuer sans le header
  }

  // Si pas d'espace sélectionné, continuer sans modification
  return next(req);
};

